var CookieBanner;

CookieBanner = (function() {
  function CookieBanner(el) {
    this.el = el;
    this.$el = $(this.el);
    this.$body = $('#ls-body');
    this.initialize();
  }

  CookieBanner.prototype.initialize = function() {
    this.delay = 300;
    if (!Cookie.get('acknowledge_cookies')) {
      this.$body.addClass('ls-visible-cookieBanner');
      this.$el.fadeIn(this.delay);
      return this.attachHideListener();
    }
  };

  CookieBanner.prototype.attachHideListener = function() {
    var acknowledgeLink;
    acknowledgeLink = this.$el.find('#ls-accept-cookies');
    return acknowledgeLink.one('click.cookie-banner-action', (function(_this) {
      return function(e) {
        e.preventDefault();
        Groupon.Utils.setSiteCookies({
          acknowledge_cookies: true
        });
        _this.$el.fadeOut(_this.delay).remove();
        return _this.$body.removeClass('ls-visible-cookieBanner');
      };
    })(this));
  };

  return CookieBanner;

})();

window.CookieBanner = CookieBanner;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvZ2lnX2JvZHkvY29tcG9uZW50cy9jb29raWVfYmFubmVyL2Zyb250ZW5kL21haW4uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvZ2lnX2JvZHkvY29tcG9uZW50cy9jb29raWVfYmFubmVyL2Zyb250ZW5kL21haW4uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQU07RUFDUyxzQkFBQyxFQUFEO0lBQUMsSUFBQyxDQUFBLEtBQUQ7SUFDWixJQUFDLENBQUEsR0FBRCxHQUFPLENBQUEsQ0FBRSxJQUFDLENBQUEsRUFBSDtJQUNQLElBQUMsQ0FBQSxLQUFELEdBQVMsQ0FBQSxDQUFFLFVBQUY7SUFDVCxJQUFDLENBQUEsVUFBRCxDQUFBO0VBSFc7O3lCQUtiLFVBQUEsR0FBWSxTQUFBO0lBQ1YsSUFBQyxDQUFBLEtBQUQsR0FBUztJQUNULElBQUEsQ0FBTyxNQUFNLENBQUMsR0FBUCxDQUFXLHFCQUFYLENBQVA7TUFDRSxJQUFDLENBQUEsS0FBSyxDQUFDLFFBQVAsQ0FBZ0IseUJBQWhCO01BQ0EsSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksSUFBQyxDQUFBLEtBQWI7YUFDQSxJQUFDLENBQUEsa0JBQUQsQ0FBQSxFQUhGOztFQUZVOzt5QkFPWixrQkFBQSxHQUFvQixTQUFBO0FBQ2xCLFFBQUE7SUFBQSxlQUFBLEdBQWtCLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLG9CQUFWO1dBQ2xCLGVBQWUsQ0FBQyxHQUFoQixDQUFvQiw0QkFBcEIsRUFBa0QsQ0FBQSxTQUFBLEtBQUE7YUFBQSxTQUFDLENBQUQ7UUFDaEQsQ0FBQyxDQUFDLGNBQUYsQ0FBQTtRQUNBLE9BQU8sQ0FBQyxLQUFLLENBQUMsY0FBZCxDQUE2QjtVQUFBLG1CQUFBLEVBQXFCLElBQXJCO1NBQTdCO1FBQ0EsS0FBQyxDQUFBLEdBQUcsQ0FBQyxPQUFMLENBQWEsS0FBQyxDQUFBLEtBQWQsQ0FBb0IsQ0FBQyxNQUFyQixDQUFBO2VBQ0EsS0FBQyxDQUFBLEtBQUssQ0FBQyxXQUFQLENBQW1CLHlCQUFuQjtNQUpnRDtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBbEQ7RUFGa0I7Ozs7OztBQVF0QixNQUFNLENBQUMsWUFBUCxHQUFzQiJ9
